import axios from 'axios'

export const startFeedbackAutomation = async () => {
	return await axios.get(`http://localhost:3001/api/bot-automation/feedback`)
}
export const startPraiseAutomation = async () => {
	return await axios.get(`http://localhost:3001/api/bot-automation/praise`)
}
